export type GeolocationOutcome =
  | { status: "granted"; lat: number; lng: number }
  | { status: "denied" }
  | { status: "unsupported" }
  | { status: "error"; message: string };

/**
 * A fresh fix, on demand. Never cache the result across calls — the API validates position at
 * write time, and legacy's 10-minute cache let people walk out and keep requesting. Denial is a
 * normal outcome here, not an error to alarm over.
 */
export function getFreshPosition(): Promise<GeolocationOutcome> {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve({ status: "unsupported" });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({ status: "granted", lat: position.coords.latitude, lng: position.coords.longitude }),
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          resolve({ status: "denied" });
        } else {
          resolve({ status: "error", message: error.message });
        }
      },
      { enableHighAccuracy: false, timeout: 10_000, maximumAge: 0 },
    );
  });
}
